
import * as echarts from 'echarts';
import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class EchartsComponent extends Vue {
  getChart1Data() {
    const renewData = [
      { value: Math.floor(Math.random() * 1000) + 1, name: '已续费' },
      { value: Math.floor(Math.random() * 1000) + 1, name: '未续费' },
    ];
    const continuedChargingData = [
      { value: Math.floor(Math.random() * 1000) + 1, name: '考虑中' },
      { value: Math.floor(Math.random() * 1000) + 1, name: '暂不续费' },
      { value: Math.floor(Math.random() * 1000) + 1, name: '续签成功' },
    ];
    const renewOption = {
      title: {
        text: '续费情况',
        left: 'center',
      },
      tooltip: {
        trigger: 'item',
      },
      legend: {
        top: '5%',
        orient: 'vertical',
        right: 10,
        itemGap: 5, // 默认 10
      },
      series: [
        {
          name: '续费情况',
          type: 'pie',
          radius: ['20%', '40%'],
          data: renewData,
          label: {
            formatter: '{d}%',
            rich: {
              time: {
                fontSize: 10,
                color: '#999',
              },
              name: {
                fontSize: 10,
                color: '#999',
              },
            },
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      ],
    };
    const continuedChargingOption = {
      title: {
        text: '续充占比',
        left: 'center',
      },
      tooltip: {
        trigger: 'item',
      },
      legend: {
        top: '5%',
        orient: 'vertical',
        right: 10,
        itemGap: 5, // 默认 10
      },
      series: [
        {
          name: '续充占比',
          type: 'pie',
          radius: '40%',
          label: {
            formatter: '{d}%',
            rich: {
              time: {
                fontSize: 10,
                color: '#999',
              },
              name: {
                fontSize: 10,
                color: '#999',
              },
            },
          },
          data: continuedChargingData,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      ],
    };
    this.echartsInit('renew', renewOption);
    this.echartsInit('ContinuedCharging', continuedChargingOption);
  }

  echartsInit(id: string, option: any) {
    const chart = echarts.init(document.getElementById(id));
    setTimeout(() => {
      chart && chart.setOption(option);
    }, 1000);
  }
}
